import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class ChatParticipant extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "chat-participant";
    static pluralName = "chat-participants";

    constructor() {
        super(ChatParticipant.kind, ChatParticipant.singularName, ChatParticipant.pluralName);
    }

    async getAll(query = {}) {
        const qs = require("qs");
        return this.fetch(qs.stringify(query, {encodeValuesOnly: true}));
    }

    async getById(id, query = {}) {
        return this.find(id, query);
    }
}
